import * as ItemActions from 'libs/gb-front/item/data-access/src/lib/+state/items.actions'
import { Injectable } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Action } from '@ngrx/store'
import { Subscription, skip, tap, Observable } from 'rxjs'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class GbAuctionUrlChangeService {
  auctionUrlNameSub!: Subscription | undefined

  /**
   * Actions to be dispatched on the Url change, add to this list as needed
   */

  auctionUrlNameChangeActions: Action[] = [ItemActions.clearItemsState()]

  /**
   * Emits the urlName whenever it changes, skip the first
   * value to ignore the urlName emission on app refresh and
   * the first load
   */

  auctionUrlNameChange$: Observable<string> = this.auctionFacade.auctionUrlName$.pipe(
    skip(1),
    tap((url) => {
      this.onUrlChange()
    }),
  )

  constructor(private auctionFacade: AuctionFacade) {}

  watchUrlChange() {
    if (!this.auctionUrlNameSub)
      this.auctionUrlNameSub = this.auctionUrlNameChange$.pipe(untilDestroyed(this)).subscribe()
  }

  onUrlChange() {
    this.auctionUrlNameChangeActions.forEach((action) => {
      this.auctionFacade.dispatch(action)
    })
  }
}
